import { render, staticRenderFns } from "./EngFooter.vue?vue&type=template&id=66234739&scoped=true"
import script from "./EngFooter.vue?vue&type=script&lang=js"
export * from "./EngFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66234739",
  null
  
)

export default component.exports